document.addEventListener('DOMContentLoaded', function() {
  // --- GENDER TABS (Men/Women) ---
  const genderBtns = document.querySelectorAll('.gender-tab-btn');
  const genderPanels = document.querySelectorAll('.size-chart');

  genderBtns.forEach(btn => {
    btn.addEventListener('click', function() {
      const targetId = this.getAttribute('data-gender-target');
      
      genderBtns.forEach(b => b.classList.remove('active'));
      genderPanels.forEach(p => p.classList.remove('active'));
      
      this.classList.add('active');
      const targetPanel = document.getElementById(targetId);
      
      if (targetPanel) {
        targetPanel.classList.add('active');
        // Trigger the first sub-tab automatically
        const firstSubTab = targetPanel.querySelector('.size-chart__tab-btn');
        if (firstSubTab) firstSubTab.click();
      }
    });
  });

  // --- PRODUCT CATEGORY TABS (Tops, Bottoms, etc.) ---
  const tabButtons = document.querySelectorAll('.size-chart__tab-btn');
  const panels = document.querySelectorAll('.size-chart__panel');

  tabButtons.forEach(button => {
    button.addEventListener('click', function() {
      const targetId = this.getAttribute('data-tab-target');
      const parentChart = this.closest('.size-chart'); // Scope to current gender

      // Reset buttons and panels within this scope
      parentChart.querySelectorAll('.size-chart__tab-btn').forEach(btn => btn.classList.remove('size-chart__tab-btn--active'));
      parentChart.querySelectorAll('.size-chart__panel').forEach(p => {
        p.classList.remove('size-chart__panel--show');
        p.classList.add('size-chart__panel--hidden');
      });

      this.classList.add('size-chart__tab-btn--active');
      const targetPanel = document.getElementById(targetId);
      if (targetPanel) {
        targetPanel.classList.remove('size-chart__panel--hidden');
        targetPanel.classList.add('size-chart__panel--show');
        
        // Pass the panel to the guide toggle function
        updateGuideVisibility(targetPanel);
      }
    });
  });

  // --- UNIT TOGGLE (IN/CM) ---
  const allToggles = document.querySelectorAll('.size-chart__toggle-input');
  
  allToggles.forEach(toggle => {
    toggle.addEventListener('change', function() {
      const isChecked = this.checked;
      const unit = isChecked ? 'cm' : 'in';

      // Sync all toggles on the page
      allToggles.forEach(t => t.checked = isChecked);

      // Update all data cells
      document.querySelectorAll('.size-chart__table-cell[data-val-cm]').forEach(cell => {
        cell.textContent = isChecked ? cell.getAttribute('data-val-cm') : cell.getAttribute('data-val-in');
      });

      // Update suffixes
      document.querySelectorAll('.size-chart__unit-suffix').forEach(s => {
        s.textContent = `(${unit})`;
      });

      // Update height guide buttons
      document.querySelectorAll('.height-tab-btn').forEach(btn => {
        btn.textContent = isChecked ? btn.getAttribute('data-height-cm') : btn.getAttribute('data-height-in');
      });
    });
  });

  // --- HEIGHT GUIDE TABS (Inside Length Guide) ---
  document.querySelectorAll('.height-tab-btn').forEach(btn => {
    btn.addEventListener('click', function() {
      const parent = this.closest('.length-guide__height-selector');
      const targetId = this.getAttribute('data-target');

      parent.querySelectorAll('.height-tab-btn').forEach(b => b.classList.remove('size-chart__tab-btn--active'));
      parent.querySelectorAll('.height-content').forEach(c => {
        c.classList.remove('size-chart__panel--show');
        c.classList.add('size-chart__panel--hidden');
      });

      this.classList.add('size-chart__tab-btn--active');
      const targetContent = document.getElementById(targetId);
      if (targetContent) {
        targetContent.classList.remove('size-chart__panel--hidden');
        targetContent.classList.add('size-chart__panel--show');
      }
    });
  });
});

function updateGuideVisibility(activePanel) {
  const showBra = activePanel.getAttribute('data-show-bra') === 'true';
  const showLength = activePanel.getAttribute('data-show-length') === 'true';
  const category = activePanel.getAttribute('data-category') || "";
  const isFootwear = category.includes('shoes') || category.includes('socks');

  const container = activePanel.closest('.size-chart');

  container.querySelectorAll('.size-chart__bra-table').forEach(el => el.style.display = showBra ? 'block' : 'none');
  container.querySelectorAll('.size-chart__length-table').forEach(el => el.style.display = showLength ? 'block' : 'none');
  container.querySelectorAll('.size-chart__measure-table').forEach(el => el.style.display = isFootwear ? 'none' : 'block');
}